/*
  FormattedMessages.js - FormattedMessages for singleview webSMSUsers component

  Author: Julius Klaebe (2019)
  Company: Virtual Ark
*/

// NPM MODULES
import React from 'react';
import { FormattedMessage } from 'react-intl';

const FormattedMessages = {
  addNew: <FormattedMessage id="Global.AddNew" defaultMessage="Add New" />,
  backToUser: (
    <FormattedMessage id="Global.backToUser" defaultMessage="Back to User" />
  ),
  addNewUser: (
    <FormattedMessage id="Global.AddNew" defaultMessage="Add New User" />
  ),
  userInformation: (
    <FormattedMessage
      id="Global.userInformation"
      defaultMessage="User Information"
    />
  ),
  editCountry: (
    <FormattedMessage id="Global.EditCountry" defaultMessage="Country:" />
  ),
  webSMSUsers: (
    <FormattedMessage id="Global.WebSMSUsers" defaultMessage="WebSMS Users" />
  ),
  completeSMSUsers: (
    <FormattedMessage id="Global.WebSMSUsers" defaultMessage="Users" />
  ),
  searchForUsers: (
    <FormattedMessage
      id="Global.SearchForUsers"
      defaultMessage="Search Users"
    />
  ),
  costCentersTitle: (
    <FormattedMessage
      id="Global.CostCentersTitle"
      defaultMessage="Cost Centers"
    />
  ),
  language: (
    <FormattedMessage id="Global.Language" defaultMessage="* Language" />
  ),
  country: <FormattedMessage id="Global.Country" defaultMessage="* Country" />,
  loading: <FormattedMessage id="Global.Loading" defaultMessage="Loading..." />,
  addDN: (
    <FormattedMessage
      id="Global.AddDn"
      defaultMessage="Manage Dedicated Numbers"
    />
  ),
  maxSmsPerDay: (
    <FormattedMessage
      id="Global.MaxSmsPerDay"
      defaultMessage="Max SMS Per Day"
    />
  ),
  userName: <FormattedMessage id="Global.UserNme" defaultMessage="User Name" />,
  errTextUserName: (
    <FormattedMessage
      id="Global.ErrTextUserName"
      defaultMessage="User Name is required"
    />
  ),
  errTextEmail: (
    <FormattedMessage
      id="Global.ErrTextUserEmail"
      defaultMessage="Email is required"
    />
  ),
  errTextEmailCheck: (
    <FormattedMessage
      id="Global.ErrTextEmailCheck"
      defaultMessage="The email provided is not in a valid format."
    />
  ),
  errTextCountry: (
    <FormattedMessage
      id="Global.ErrTextCountry"
      defaultMessage="Country selection is required"
    />
  ),
  errTextLanguage: (
    <FormattedMessage
      id="Global.ErrTextLanguage"
      defaultMessage="Language selection is required"
    />
  ),
  errTextCostCenter: (
    <FormattedMessage
      id="Global.ErrTextCostCenter"
      defaultMessage="Select a Cost Center."
    />
  ),
  errCheckPhoneFormat: (
    <FormattedMessage
      id="Global.ErrTextCostCenter"
      defaultMessage="Incorrect user mobile format, should only contain numbers and '+', eg: +0123456789/0123456789"
    />
  ),
  errTextPassword: (
    <FormattedMessage
      id="Global.ErrTextPassword"
      defaultMessage="Password is required"
    />
  ),
  errCheckPasswordStrong: (
    <FormattedMessage
      id="Global.ErrCheckPasswordStrong"
      defaultMessage="Password is not strong enough. Please ensure it is 8 or more characters long and contains at least one uppercase and one lowercase letter, a number and a symbol."
    />
  ),
  errTextMaxSms: (
    <FormattedMessage
      id="Global.ErrTextMaxSms"
      defaultMessage="Max SMS Per Day must be a positive number"
    />
  ),
  errBlankMaxSms: (
    <FormattedMessage
      id="Global.ErrBlankMaxSms"
      defaultMessage="Max SMS is required"
    />
  ),
  errCheckPassword: (
    <FormattedMessage
      id="Global.ErrCheckPassword"
      defaultMessage="Requires a password in both password fields."
    />
  ),
  errCheckPasswordMatch: (
    <FormattedMessage
      id="Global.ErrCheckPasswordTwo"
      defaultMessage="Passwords don't match."
    />
  ),
  errForwardToNumberFormat: (
    <FormattedMessage
      id="Global.ErrTextCostCenter"
      defaultMessage="Incorrect forward calls to number format, should only be +[country code][phone number], eg: +1234567890"
    />
  ),
  modalCancel: (
    <FormattedMessage id="Global.modalCancel" defaultMessage="Cancel" />
  ),
  modalYes: <FormattedMessage id="Global.modalYes" defaultMessage="Yes" />,
  modalWarning: (
    <FormattedMessage id="Global.modalWarning" defaultMessage="Warning" />
  ),
  modalBody: (
    <FormattedMessage
      id="Global.modalBody"
      defaultMessage="A number you want to release appears to be a legacy number based on the name. Are you sure you want to release that number?"
    />
  ),
  dedicatedNumber: (
    <FormattedMessage
      id="Global.dedicatedNumber"
      defaultMessage="Dedicated Number(s)"
    />
  ),
  saving: <FormattedMessage id="Global.Saving" defaultMessage="Saving..." />,
  saveChanges: (
    <FormattedMessage id="Global.saveChanges" defaultMessage="Save Changes" />
  ),
  campaign: <FormattedMessage id="Global.Campaign" defaultMessage="Campaign" />,
  deviceName: (
    <FormattedMessage id="Global.DeviceName" defaultMessage="Device Name" />
  ),
  release: <FormattedMessage id="Global.Release" defaultMessage="Release?" />,
  gateway: <FormattedMessage id="Global.Gateway" defaultMessage="Gateway" />,
  searchButton: <FormattedMessage id="Global.Search" defaultMessage="Search" />,
  noUsersFound: (
    <FormattedMessage
      id="Global.NoUsersFound"
      defaultMessage="No users found"
    />
  ),
  usersFound: (
    <FormattedMessage id="Global.UsersFound" defaultMessage="Users Found" />
  ),
  email: <FormattedMessage id="Global.Email" defaultMessage="Email" />,
  name: <FormattedMessage id="Global.Name" defaultMessage="Name" />,
  cell: <FormattedMessage id="Global.Cell" defaultMessage="Mobile Number" />,
  status: <FormattedMessage id="Global.Status" defaultMessage="Status" />,
  type: <FormattedMessage id="Global.Type" defaultMessage="Type" />,
  active: <FormattedMessage id="Global.Active" defaultMessage="Active" />,
  inactive: <FormattedMessage id="Global.Inactive" defaultMessage="Inactive" />,
  primary: <FormattedMessage id="Global.Primary" defaultMessage="Primary" />,
  maxDailyMessage: (
    <FormattedMessage
      id="Global.MaxDailyMessage"
      defaultMessage="Max. Msgs/Day"
    />
  ),
  messageText: (
    <FormattedMessage
      id="Global.MessageText"
      defaultMessage="Message Priority"
    />
  ),
  mobileText: (
    <FormattedMessage id="Global.MobileText" defaultMessage="Mobile" />
  ),
  deliveryReceiptsText: (
    <FormattedMessage
      id="Global.DeliveryReceiptsText"
      defaultMessage="Receipt Flag"
    />
  ),
  deleteText: (
    <FormattedMessage id="Global.DeleteText" defaultMessage="Delete User" />
  ),
  transferTo: (
    <FormattedMessage id="Global.TransferTo" defaultMessage="Transfer To" />
  ),
  transfer: <FormattedMessage id="Global.Transfer" defaultMessage="Transfer" />,
  transferNumber: (
    <FormattedMessage
      id="Global.TransferNumber"
      defaultMessage="Transfer Number"
    />
  ),
  transferDetails: (
    <FormattedMessage
      id="Global.TransferDetails"
      defaultMessage="Enter the details to transfer"
    />
  ),
  confirmTransfer: (
    <FormattedMessage
      id="Global.ConfirmTransfer"
      defaultMessage="Confirm Transfer"
    />
  ),
  searchAvailableNumbers: (
    <FormattedMessage
      id="Global.SearchAvailableNumbers"
      defaultMessage="Search for available numbers"
    />
  ),
  searching: (
    <FormattedMessage id="Global.Searching" defaultMessage="Searching..." />
  ),
  provisionSelected: (
    <FormattedMessage
      id="Global.ProvisionSelected"
      defaultMessage="Provision selected"
    />
  ),
  provisioning: (
    <FormattedMessage
      id="Global.Provisioning"
      defaultMessage="Provisioning..."
    />
  ),
  releaseSelected: (
    <FormattedMessage
      id="Global.ReleaseSelected"
      defaultMessage="Release selected"
    />
  ),
  releasing: (
    <FormattedMessage id="Global.Releasing" defaultMessage="Releasing..." />
  ),
  prefix: <FormattedMessage id="Global.Prefix" defaultMessage="Prefix" />,
  prefixError: (
    <FormattedMessage
      id="Global.PrefixError"
      defaultMessage="Requires a 3-digit prefix."
    />
  ),
  phoneNumber: (
    <FormattedMessage id="Global.PhoneNumber" defaultMessage="Phone Number" />
  ),
  locality: <FormattedMessage id="Global.Locality" defaultMessage="Locality" />,
  provision: (
    <FormattedMessage id="Global.Provision" defaultMessage="Provision?" />
  ),
  emailRequired: (
    <FormattedMessage
      id="Global.EmailRequired"
      defaultMessage="Requires a user email address"
    />
  ),
  errorTransferring: (
    <FormattedMessage
      id="Global.ErrorTransferring"
      defaultMessage="Error transferring number"
    />
  ),
  errorChangingCampaign: (
    <FormattedMessage
      id="Global.ErrorChangingCampaign"
      defaultMessage="Error changing campaign"
    />
  ),
  notApplicable: (
    <FormattedMessage id="Global.NotApplicable" defaultMessage="N/A" />
  ),
  password: <FormattedMessage id="Global.Password" defaultMessage="Password" />,
  confirmPassword: (
    <FormattedMessage
      id="Global.ConfirmPassword"
      defaultMessage="Confirm Password"
    />
  ),
  numberContains: (
    <FormattedMessage
      id="Global.NumberContains"
      defaultMessage="Number Contains"
    />
  ),
  numberContainsTooltip: (
    <FormattedMessage
      id="Global.NumberContainsTooltip"
      defaultMessage="This field requires more than one digit. Twilio supports wildcard searches with '*', where * represents any single digit (e.g. '812**3')."
    />
  ),
  admin: <FormattedMessage id="Global.Admin" defaultMessage="Administrators" />,
  costCenters: (
    <FormattedMessage id="Global.CostCenters" defaultMessage="Cost Centers" />
  ),
  users: <FormattedMessage id="Global.Users" defaultMessage="Users" />,
  findUser: (
    <FormattedMessage id="Global.FindUser" defaultMessage="Find User" />
  ),
  companyProfile: (
    <FormattedMessage
      id="Global.CompanyProfile"
      defaultMessage="Company Profile"
    />
  ),
};

export default FormattedMessages;
